<template>
    <div class="d-flex content-container h-100 overflow-hidden">
        <page-header
            :page-icon="null"
            removeBackButton
            close-button
            @back="backToStream"
        />
        <transition-block
            :title="trans(`streams.transitions.${currentState}.title`)"
            :overline="trans(`streams.transitions.${currentState}.overline`)"
            :description="trans(`streams.transitions.${currentState}.description`)"
            :image="transitionImage"
            :primary-button="transitionButtons ? transitionButtons.primary : null"
            :secondary-button="transitionButtons ? transitionButtons.secondary : null"
            @onPrimary="checkNextStep('primary')"
            @onSecondary="checkNextStep('secondary')"
        >
            <evaluation-form
                v-if="currentState === 'evaluation'"
                :feedback-val="feedback"
                :grade-val="grade"
                :loading="loading"
                @submitEval="onSubmit"
                :feedback-label="trans('miu.evaluation.question_title')"
                :skip-button="trans('miu.evaluation.skip')"
                @skipEval="onSkipEval"
            />
            <dashboard-card
                v-if="currentState === 'next_element'"
                :icon="setCardIcon(nextElement)"
                :completed="false"
                :type="trans(elementTypeTitle(nextElement.type))"
                :title="nextElement.title"
                :description="nextElement.short_description"
                :options="nextElement.softskills"
                :week-number="nextElement.weekNumber"
            />
        </transition-block>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import EvaluationForm from "../EvaluationForm";
import PageHeader from "../PageHeader";
import TransitionBlock from "./TransitionBlock";
import DashboardCard from "../../molecules/DashboardCard";
import streamMixin from "../../mixins/streamMixin";

export default {
    name: "EndOfMiu",
    components: {DashboardCard, TransitionBlock, PageHeader, EvaluationForm},
    data() {
        return {
            grade: '',
            feedback: '',
            loading: false,
            activityData: [],
            currentState: this.$route.params.state ? this.$route.params.state : 'evaluation',
            isLoading: false
        };
    },
    methods:{
        ...mapActions({
            submitActivity: 'streams/submitActivity'
        }),
        async onSubmit(grade, feedback) {
            this.grade = grade;
            this.feedback = feedback;

            const routeParams = this.$route.params;

            let data = {
                main: {
                    action: "evaluated",
                    objectId: routeParams.id,
                    objectType: this.currentElementType,
                },
                details: [
                    {
                        key: "grade",
                        value: grade
                    },
                    {
                        key: "feedback",
                        value: feedback
                    }
                ]
            }

            let activityData = [];

            activityData.push(data);
            await this.submitActivity({data: activityData});

            this.checkNextStep();
            this.loading = false;

            trackEvent('ModuleEvaluation', {
                grade: this.grade,
                elementType: this.currentElementType,
                elementId: this.id,
            })
        },
        onSkipEval(){
            this.checkNextStep();

            trackEvent('SkipEvaluation', {
                elementType: this.currentElementType,
                elementId: this.id,
            });
        },
        checkNextStep(action){
            switch (this.currentState){
                case 'evaluation':
                    if(!this.nextElement){
                        this.backToStream();
                    }else if(this.nextElement.final){
                        this.currentState = 'ale_completed';
                    }else if(this.nextElement.break){
                        this.currentState = 'break_time'
                    }else{
                        this.currentState = 'next_element';
                    }
                    break;
                case 'next_element':
                    const routeParams = this.$route.params
                    if(action === 'primary'){
                        const route = this.itemRoute(
                            routeParams.id,
                            routeParams.aleId,
                            routeParams.localisation,
                            this.nextElement,
                            this.nextElement.completed ? 'review' : 'instructions');
                        this.$router.push(route).catch(err => {
                            console.log(err);
                            this.backToStream()
                        });
                    }else{
                        this.backToStream();
                    }
                    break;
                case 'ale_completed':
                case 'break_time':
                    this.backToStream();
                    break;
            }
        },
        backToStream(){
            this.$router.push({name: 'stream', id: this.$route.params.id})
        },

    },
    computed:{
        ...mapGetters({
            currentElementTitle: 'streams/getCurrentElementTitle',
            currentElementType: 'streams/getCurrentElementType',
            elementSoftSkills: 'streams/getElementSoftSkill',
            nextElement: 'streams/getNextElement',
            aleId: 'streams/getCurrentAleId',
            aleType: 'streams/getCurrentAleType'
        }),
        transitionButtons(){
            let primaryButton = {
                text: this.trans(`streams.transitions.${this.currentState}.primary_button`)
            }
            let secondaryButton = null;

            switch (this.currentState){
                case 'evaluation':
                    return null;
                case 'next_element':
                    secondaryButton = {
                        text: this.trans(`streams.transitions.${this.currentState}.secondary_button`)
                    }
                    break;
                case 'break_time':
                    break;
                case 'ale_completed':
                    break;
            }

            return {primary: primaryButton, secondary: secondaryButton}
        },
        transitionImage(){
            switch (this.currentState){
                case 'break_time':
                case 'ale_completed':
                    return `/images/streams/${this.currentState}.svg`;
                default:
                    return null
            }
        },
    },
    mixins: [streamMixin]
}
</script>